module.exports = __webpack_public_path__ + "img/h-page4-64.b9b4e7a2.png";